module.exports = __webpack_public_path__ + "media/images/file-3a671617.svg";